import React from 'react';
import Banner from '../../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../../assets/images/satellite/banner.png";
const OutsourcingRisksBanner = (props) => (
    <Banner
        id="outsourcing-risks-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingRisks.section-1.title"
        text="services:outsourcingRisks.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        timeDelay={1.55}
        noText
    />
);

export default OutsourcingRisksBanner;
